import { GET_SECURITY_OPTIONS_USE_CASE, GetSecurityOptionsUseCase, SECURITY_OPTION_REPOSITORY } from '@module/assignment';
export var securityOptionUseCaseProviders = [{
  provide: GET_SECURITY_OPTIONS_USE_CASE,
  useFactory: function useFactory(securityOptionRepository) {
    return new GetSecurityOptionsUseCase(securityOptionRepository);
  },
  inject: [SECURITY_OPTION_REPOSITORY]
}];